// Arabic labels for period codes (mirrors PERIODS_CHOICES in school_BE/students/models.py)
export const PERIOD_LABELS = {
  period_1: 'الحصة الأولى',
  period_2: 'الحصة الثانية',
  period_3: 'الحصة الثالثة',
  period_4: 'الحصة الرابعة',
  period_5: 'الحصة الخامسة',
  period_6: 'الحصة السادسة',
  period_7: 'الحصة السابعة',
  period_8: 'الحصة الثامنة',
  period_9: 'الحصة التاسعة',
  period_10: 'الحصة العاشرة'
};

// Display name for a period timing slot, e.g. { period: 'period_1' } -> 'الحصة الأولى'
export const getPeriodLabel = (slot) => {
  if (!slot) return '';
  const code = slot.period || slot.id;
  return slot.period_display || PERIOD_LABELS[code] || code || '';
};
